import type { SVGProps } from "react";

export function IconBlackBenchmarks(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1895 2.25H21.7501V10.8107L18.0001 7.06066L13.0001 12.0607L9.00011 8.06066L2.25 14.8108V12.6895L9.00011 5.93934L13.0001 9.93934L16.9395 6L13.1895 2.25ZM2.25 21V21.75H7.75V12.4926L2.25 17.9926V21ZM14.75 21.75H9.25V11.4927L13 15.2426L14.75 13.4926V21.75ZM16.25 11.9926V21.75H21.75V13.9927L18 10.2426L16.25 11.9926Z"
        fill="#0B0C17"
      />
    </svg>
  );
}
